import React from 'react';
import { Helmet } from "react-helmet";
import './AccessCodeRegister.scss';
import { useHistory } from 'react-router-dom';
import AccessCodeForm from './AccessCodeForm';
import useMediaQuery from '@material-ui/core/useMediaQuery';

export default function AccessCodeRegister(props) {
  const history = useHistory();
    const isMobile = !useMediaQuery('(min-width:768px)');
    const isIpad = useMediaQuery('(min-width:768px) and (max-width:1024px)');

  return (
    <>
        <Helmet>
            <title>Register for ActiveHub</title>
        </Helmet>
        <div className="row m-0 register-desktop new-user-mobile-tab-responsive">
        <div className='breadcrum'>
            <div className="text" onClick={()=> history.push(`/login`)}>ActiveHub</div>
            <div className='symbol'>
                <img src={`${process.env.PUBLIC_URL}/images/greater-icon.svg`} width="10" height="10" alt="greater icon" />
            </div>
            <div className="active">Register for ActiveHub</div>
        </div>
        <div className="row m-0 access-code-container w-100">
            <div className="col-12 col-md-12">
                <div className="row">
                    <div className="header-register">
                        <div>
                        <img
                          src={isMobile || isIpad ? `${process.env.PUBLIC_URL}/activehub-logo-mobile.svg` : `${process.env.PUBLIC_URL}/activehub-logo.svg`}
                          alt="activehub-logo"
                          className="activehub-access-code-logo"
                        />
                        </div>
                       <h1 className="title">Register for ActiveHub</h1>                       
                    </div>
                </div>
            </div>
            <div className="col-12 col-md-12">
                <div className="table-row">
                    <div></div>
                    <div className="table-register">
                        <AccessCodeForm />
                    </div>
                </div>
            </div>
        </div>
        <div className="wrapper">
        </div>
    </div>
    </>
  )
}